// Neu (SPEC 03 §5.5). multipart/form-data, Feld "datei"; KEIN eigener Content-Type
// (die boundary setzt der Browser); X-HS: 1 wie fetchJson.
//
// fetch kennt keinen Upload-Fortschritt, PDFs sind bis zu MAX_PDF = 300 MB groß (02 §1.3) —
// darum ein XMLHttpRequest je Datei. Dateien gehen NACHEINANDER hoch, nie parallel
// (Serverdeckel UPLOADS_PRO_STUNDE = 30, Platte).
import { abmeldenMelden, ApiError, meldungAus, standardMeldung } from "../lib/fetchJson";

export function hochladen<T>(
  pfad: string,
  datei: File,
  o: { beiFortschritt?: (geladen: number, gesamt: number) => void; signal?: AbortSignal } = {},
): Promise<{ status: number; body: T }> {
  return new Promise((ok, nein) => {
    const x = new XMLHttpRequest();
    x.open("POST", "/api" + pfad);
    x.withCredentials = false; // same-origin schickt das Cookie ohnehin
    x.setRequestHeader("X-HS", "1");
    x.setRequestHeader("Accept", "application/json");
    x.responseType = "text";
    x.upload.onprogress = (e) => {
      if (e.lengthComputable) o.beiFortschritt?.(e.loaded, e.total);
    };
    x.onerror = () => nein(new ApiError(0, standardMeldung(0), null, pfad));
    x.onabort = () => nein(new DOMException("Abgebrochen", "AbortError"));
    x.onload = () => {
      let body: unknown = null;
      try {
        body = x.responseText ? JSON.parse(x.responseText) : null;
      } catch {
        body = x.responseText;
      }
      if (x.status >= 400) {
        if (x.status === 401) abmeldenMelden();
        nein(new ApiError(x.status, meldungAus(body, x.status), body, pfad));
      } else ok({ status: x.status, body: body as T });
    };
    if (o.signal) {
      if (o.signal.aborted) {
        nein(new DOMException("Abgebrochen", "AbortError"));
        return;
      }
      o.signal.addEventListener("abort", () => x.abort());
    }
    const fd = new FormData();
    fd.append("datei", datei, datei.name);
    x.send(fd);
  });
}
